import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AlertService } from '../../alert';
import { PackagingService } from '../../services/packaging.service';

@Component({
  selector: 'packaging-item',
  providers: [PackagingService],
  templateUrl: './packaging-item.component.html',
  styleUrls: ['./packaging-item.component.css']
})
export class PackagingItemComponent implements OnInit {

  loading = false;
  packaging: any  = {};

  constructor(
    private packagingService: PackagingService,
    private route: ActivatedRoute,
    private alertService: AlertService) { }

  ngOnInit() {
    let reference = this.route.snapshot.params['id'];
    if (reference == "new") {
      // no specific logic
    } else {
      // do nothing
    }
  }

  save() {
    this.loading = true;
    // Remove leading and trailing spaces. Replace spaces in name with _
    let name: string = this.packaging.name;
    name = name.trim();
    this.packaging.name = name.replace(' ', '_');
    this.packagingService.addPackaging(this.packaging)
      .subscribe(
        data => {
          this.alertService.success("Verpackung erfolgreich gespeichert");
          this.loading = false;
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/packaging/packaging-item/packaging-item.component.ts